import { createQueryKey } from 'src/utils/query/createQueryKey';

export const orderbookQueryKeys = {
	l2Orderbook: (marketId?: string) => createQueryKey('l2Orderbook', marketId),
	marketPriceState: (marketId?: string) =>
		createQueryKey('marketPriceState', marketId),
};
